<template>
	<div class="toyota" :class="['loginwrapper',$style.loginwrapper]">
		<div :class="$style.header">
			<img :src="toyota" :class="$style.logo_toyota"/>
			<div :class="$style.app_title">{{str('app_title')}}</div>
			<img :src="lexus" :class="$style.logo_lexus"/>
		</div>

		<div :class="$style.content_container">

			<div style="position: relative; top: 25%; text-align:center; color: #aaa; font-size: 1.5em;">
				{{ 'signing_in' | str}} ... 
				<br>
			</div>

<!-- 					
			<div :class="$style.content">
				<div :class="$style.sub_modal"></div>

				<div style="position: relative; top: 25%; color: white; font-size: 1.5em;">
					{{ 'signing_in' | str}}
					<br>
					...

					<button :class="$style.signIn" title="Sign in" v-on:click="login">
						<i class="fa fa-sign-in-alt"></i>
						{{str('sign_in')}}
					</button>
					<Language v-on:language="language"/>
			</div>

			</div>
 -->				
		</div>

		<div :class="$style.footer">
			<div style="width: 40%; text-align:left; display: inline-block;vertical-align:center;">© 2019 Toyota Canada Inc.</div>

			<div style="width: 40%; text-align:right; display: inline-block;vertical-align:center;">
				<a href="mailto:dtsc@toyota.ca" class="nav-link">Contact Us / Contactez nous</a>
			</div>
		</div>

	</div>
</template>

<script>
// import {application} from '@/controllers/ApplicationController'
// import Language from "@/components/Language/Language.vue";
import toyota from "@/assets/logo_toyota.png";
import lexus from "@/assets/logo_lexus.png";
// import background from "@/assets/toyota_login.jpg";

export default {
	name: 'login',
	mounted: function() {
		if(this.$application.isLoggedIn()) {
			this.$router.push('/');
		}
		else if(this.$application.testLoginToken()==false) {
			this.login();
		}
	},
	components: {
		// Language
	},
	data: function() {
		return {
		}
	},
	methods: {
		login: function(){
			this.$application.login()
		},
		logout: function() {
			this.$application.logout();
		},
		str: function(val) {
			return this.$Localization.str(val);
		},
		language: function(data){
			this.$emit('language',data)
		}

	},
	computed: {
		toyota: function(){
			return toyota;
		},
		lexus: function(){
			return lexus;
		},
		// backgroundImage: function(){
		// return 'url(' + background + ')';
		// }		
	}
}

</script>


<style module>
.loginwrapper {
	/* margin: 50px auto;
    max-width: 400px;
    max-height: 300px;
    border: 1px solid #eee;
    padding: 70px;
    border-radius: 10px;
    box-shadow: -1px 1px 20px #eee; */
	height: 100vh;
	width: 100%;
	text-align: center;
}

.header{
	position: relative;
	width: 100%;
	border-bottom: 1px solid grey;
	background-color: white;
	color: darkslategrey;
	letter-spacing: -2px;
	padding-top: 20px;
}

.footer{
	position: absolute;
	padding-top: 20px;
	bottom: 0px;
	width: 100%;
	height: 35px;
	background-color: #CDD4DB;
	color: #58595b;
	font-family: "Museo Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
	font-size: 18px;
}

.footer a{
	text-decoration: none;
	color: #58595b;
}
	.footer a:hover{
		color: #0056b3;
	}

.app_title{
	display: inline-block;
	margin-bottom: 15px;
	font-size: 35px;
	font-weight: 300;
	text-transform: uppercase;
	transform: translateY(-10px);
}


.content_container{
	position: absolute;
	top: 35%;
	left: 12%;
	width: 250px;
	height: 250px;
}

.content{
	position: relative;
	height: 100%;
}

.sub_modal{
	position: absolute;
	top: 0px;
	left: 0px;
	width: 100%;
	height: 100%;
	opacity: 0.8;

    border-radius: 3px;
    background-color: #000;
    content: '';
    box-shadow: 0px 0px 2px 1px #000;	
}

.signIn{
	position: relative;
	font-size: 14pt;
	padding: 15px;
	margin: 25px;
	/* margin: 45px 0px 130px 0px; */
}

.header img{
	height: 50px;
	margin: 0px 20px;
}

.logo_toyota{
	border-right: 1px solid grey;
}

.logo_lexus{
	height: 40px !important;
	border-left: 1px solid grey;
	padding-left: 10px;
	transform: translateY(-3px);
}


@media only screen and (max-width: 935px) {
	.app_title{
		width: 80%;
		transform: translate(5px);
	}

	.content_container{
		position: relative;
		top: 10%;
		left: 50%;
		width: 300px;
		height: 350px;
		transform: translateX(-45%);
	}	

	.logo_toyota, .logo_lexus{
		height: 30px;
		display: inline-block;
		border-style: none;
		padding: 0px;
		margin: 0 auto;
	}

}
</style>

<style lang="scss">
@import "@/_variables.scss";
.loginwrapper{
	background: #eee no-repeat center center;
	background-size: cover;
	// background: radial-gradient(darkgrey, darkslategrey);
}
</style>